import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    ctaSave: 'Save',
    description:
      'In order to facilitate file tracking, please enter the company legal name as it appears in the draft statutes.',
    legalNameLabel: 'Company legal name',
    legalNameRequired: 'Company legal name is required',
    title: 'What will the legal name of your client’s company be?',
  },
  fr: {
    ctaSave: 'Enregistrer',
    description:
      'Afin de faciliter le suivi du dossier, veuillez saisir la dénomination sociale de l’entreprise comme indiqué dans le projet de statuts.',
    legalNameLabel: 'Dénomination sociale de l’entreprise',
    legalNameRequired: 'La dénomination sociale de l’entreprise est requise',
    title:
      'Quelle sera la dénomination sociale de l’entreprise de votre client·e\u00A0?',
  },
} as const);
